import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (Array.isArray(error?.error?.message))
        (error as unknown as Record<string, unknown>)['message'] = error.error.message.join(',');

      if (typeof error?.error?.message === 'string')
        (error as unknown as Record<string, unknown>)['message'] = error?.error?.message;

      return throwError(() => error);
    }),
  );
};
